import React, { useState, useEffect, useRef, useContext } from 'react';
import classNames from 'classnames';
import { Route, useHistory } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';

import { SignIn } from './components/Sign/SignIn';
import { SignUp } from './components/Sign/SignUp';

import { AppTopbar } from './AppTopbar';
import { AppFooter } from './AppFooter';
import { AppMenu } from './AppMenu';
import { AppProfile } from './AppProfile';

import { Dashboard } from './components/Dashboard';
import { Recibos } from './components/Recibos';
import { DatosPersonales } from './components/DatosPersonales';
import { ButtonDemo } from './components/ButtonDemo';
import { ChartDemo } from './components/ChartDemo';
import { Documentation } from './components/Documentation';
import { FileDemo } from './components/FileDemo';
import { FloatLabelDemo } from './components/FloatLabelDemo';
import { FormLayoutDemo } from './components/FormLayoutDemo';
import { InputDemo } from './components/InputDemo';
import { ListDemo } from './components/ListDemo';
import { MenuDemo } from './components/MenuDemo';
import { MessagesDemo } from './components/MessagesDemo';
import { MiscDemo } from './components/MiscDemo';
import { OverlayDemo } from './components/OverlayDemo';
import { PanelDemo } from './components/PanelDemo';
import { TableDemo } from './components/TableDemo';
import { TreeDemo } from './components/TreeDemo';
import { InvalidStateDemo } from './components/InvalidStateDemo';


import { Calendar } from './pages/Calendar';
import { Crud } from './pages/Crud';
import { EmptyPage } from './pages/EmptyPage';

import { DisplayDemo } from './utilities/DisplayDemo';
import { ElevationDemo } from './utilities/ElevationDemo';
import { FlexBoxDemo } from './utilities/FlexBoxDemo';
import { GridDemo } from './utilities/GridDemo';
import { IconsDemo } from './utilities/IconsDemo';
import { SpacingDemo } from './utilities/SpacingDemo';
import { TextDemo } from './utilities/TextDemo';
import { TypographyDemo } from './utilities/TypographyDemo';
import { TimelineDemo } from './utilities/TimelineDemo';
import { PrivateRoute } from './components/PrivateRoute';

import PrimeReact from 'primereact/api';
import AuthContext from './context/AuthContext';
import isMobile from './components/tools/DeviceInfo';

import 'primereact/resources/themes/saga-green/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'prismjs/themes/prism-coy.css';
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';
import './layout/flags/flags.css';
import './layout/layout.scss';
import './App.scss';

const App = () => {

    const [layoutMode, setLayoutMode] = useState('static');
    const [layoutColorMode, setLayoutColorMode] = useState('dark')
    const [inputStyle, setInputStyle] = useState('outlined');
    const [ripple, setRipple] = useState(false);
    const [sidebarActive, setSidebarActive] = useState( (isMobile.any()) ?false:true);
    const sidebar = useRef();
    const {myUser} = useContext(AuthContext);

    const history = useHistory();

    let menuClick = false;

    useEffect(() => {
        if (sidebarActive) {
            addClass(document.body, "body-overflow-hidden");
        } else {
            removeClass(document.body, "body-overflow-hidden");
        }
    }, [sidebarActive]);

    const onWrapperClick = (event) => {
        if (!menuClick && layoutMode === "overlay") {
            setSidebarActive(false);
        }
        menuClick = false;
    }

    const onToggleMenu = (event) => {
        menuClick = true;

        setSidebarActive((prevState) => !prevState);

        event.preventDefault();
    }

    const onSidebarClick = () => {
        menuClick = true;
    }

    const onMenuItemClick = (event) => {
        if (!event.item.items && layoutMode === "overlay") {
            setSidebarActive(false);
        }
        if(isSidebarVisible && isMobile.any() && !event.item.items) {
            setSidebarActive(false);
        }
    }

    const menu = [
        { label: 'Inicio', icon: 'pi pi-fw pi-home', to: '/' },
        {
            label: 'Recibos', icon: 'pi pi-fw pi-list',
            items: [
                { label: '2026', icon: 'pi pi-fw pi-calendar', to: '/recibos/2026' },
                { label: '2025', icon: 'pi pi-fw pi-calendar', to: '/recibos/2025' },
                { label: '2024', icon: 'pi pi-fw pi-calendar', to: '/recibos/2024' },
                { label: '2023', icon: 'pi pi-fw pi-calendar', to: '/recibos/2023' },
                { label: '2022', icon: 'pi pi-fw pi-calendar', to: '/recibos/2022' },
                { label: '2021', icon: 'pi pi-fw pi-calendar', to: '/recibos/2021' },
                { label: '2020', icon: 'pi pi-fw pi-calendar', to: '/recibos/2020' },
            ]
        },
        {
            label: 'Datos', icon: 'pi pi-fw pi-th-large',
            items: [
                { label: 'Datos Personales', icon: 'pi pi-fw pi-id-card', to: '/datos' },
                // { label: 'Cuenta de Acceso', icon: 'pi pi-fw pi-user', to: '/panel' },
            ]
        },
        // {   label: 'Vacaciones', icon: 'pi pi-fw pi-calendar-plus',
        // items: [
        //     { label: 'Solicitar', icon: 'pi pi-fw pi-plus-circle', to: '/input' },
        // ]}
    ];

    const addClass = (element, className) => {
        if (element.classList)
            element.classList.add(className);
        else
            element.className += ' ' + className;
    }

    const removeClass = (element, className) => {
        if (element.classList)
            element.classList.remove(className);
        else
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }

    const isSidebarVisible = () => {
        return sidebarActive;
    };

    const logo = layoutColorMode === 'dark' ? 'assets/layout/images/logoPlastiandino-white.svg' : 'assets/layout/images/logoPlastiandino-white.svg';

    const wrapperClass = classNames('layout-wrapper', {
        'layout-overlay': layoutMode === 'overlay',
        'layout-static': layoutMode === 'static',
        'layout-active': sidebarActive,
        'p-input-filled': inputStyle === 'filled',
        'p-ripple-disabled': ripple === false
    });

    const sidebarClassName = classNames('layout-sidebar', {
        'layout-sidebar-dark': layoutColorMode === 'dark',
        'layout-sidebar-light': layoutColorMode === 'light'
    });

    return (
        <div className={wrapperClass} onClick={onWrapperClick}>
            { (myUser.email !== undefined ) && (myUser.email !== '' )    &&  (
                <AppTopbar onToggleMenu={onToggleMenu} />
            )}
            {(myUser.email !== undefined ) && (myUser.email !== '' )  &&  (
                <CSSTransition classNames="layout-sidebar" timeout={{ enter: 200, exit: 200 }} in={isSidebarVisible()} unmountOnExit>
                    <div ref={sidebar} className={sidebarClassName} onClick={onSidebarClick}>
                        <div className="layout-logo" style={{cursor: 'pointer'}} onClick={() => history.push('/')}>
                            <img alt="Logo" src= {logo} width= "210"/>
                        </div>
                        <AppProfile />
                        <AppMenu model={menu} onMenuItemClick={onMenuItemClick} />
                    </div>
                </CSSTransition>
            )}

            {/* BOTON para cmaibar Configuracion */}
            {/* <AppConfig rippleEffect={ripple} onRippleEffect={onRipple} inputStyle={inputStyle} onInputStyleChange={onInputStyleChange}
                layoutMode={layoutMode} onLayoutModeChange={onLayoutModeChange} layoutColorMode={layoutColorMode} onColorModeChange={onColorModeChange} /> */}
                
            <Route path= "/login" exact component={SignIn}/>
            <Route path= "/register" exact component={SignUp}/>
            {/* <PrivateRoute path="/cuit" exact component={Dashboard} /> */}
            
            <div className="layout-main">
                <PrivateRoute path="/" exact component={Dashboard} />
                <PrivateRoute path="/recibos/:anio" exact component={Recibos} />
                <PrivateRoute path="/datos" exact component={DatosPersonales} />
                {/*<PrivateRoute path="/formlayout" component={FormLayoutDemo} />
                <PrivateRoute path="/input" component={InputDemo} />
                <PrivateRoute path="/floatlabel" component={FloatLabelDemo} />
                <PrivateRoute path="/invalidstate" component={InvalidStateDemo} />
                <PrivateRoute path="/button" component={ButtonDemo} />
                <PrivateRoute path="/table" component={TableDemo} />
                <PrivateRoute path="/list" component={ListDemo} />
                <PrivateRoute path="/tree" component={TreeDemo} />
                <PrivateRoute path="/panel" component={PanelDemo} />
                <PrivateRoute path="/overlay" component={OverlayDemo} />
                <PrivateRoute path="/menu" component={MenuDemo} />
                <PrivateRoute path="/messages" component={MessagesDemo} />
                <PrivateRoute path="/file" component={FileDemo} />
                <PrivateRoute path="/chart" component={ChartDemo} />
                <PrivateRoute path="/misc" component={MiscDemo} />
                <PrivateRoute path="/display" component={DisplayDemo} />
                <PrivateRoute path="/elevation" component={ElevationDemo} />
                <PrivateRoute path="/flexbox" component={FlexBoxDemo} />
                <PrivateRoute path="/icons" component={IconsDemo} />
                <PrivateRoute path="/grid" component={GridDemo} />
                <PrivateRoute path="/spacing" component={SpacingDemo} />
                <PrivateRoute path="/typography" component={TypographyDemo} />
                <PrivateRoute path="/text" component={TextDemo} />
                <PrivateRoute path="/calendar" component={Calendar} />
                <PrivateRoute path="/timeline" component={TimelineDemo} />
                <PrivateRoute path="/crud" component={Crud} />
                <PrivateRoute path="/empty" component={EmptyPage} />
                <PrivateRoute path="/documentation" component={Documentation} /> */}
            </div>
            
            {(myUser.email !== undefined ) && (myUser.email !== '' ) && (
                <AppFooter />
            )}

        </div>
    )

}

export default App
